import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ButtonBase from '@material-ui/core/ButtonBase';
import { getDownloadableLink } from '../../../../../../../../Helper';
import {
  ActionsEnum,
  DefaultImagesEnum,
  UnitProfileImagesCardActionEnum,
} from '../../../../../../../../Enums';
import { LoadableImageComponant, PermissionsComponent } from '../../../../../../../../Components';
import { useLocalStorage } from '../../../../../../../../Hooks';
import { ImageGalleryPermissions } from '../../../../../../../../Permissions';

export const AlbumsFooterComponent = ({
  hideIcon,
  Display,
  data,
  onFooterActionsClicked,
  parentTranslationPath,
  activeImageHandler,
  translationPath,
  activeCategory
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [language] = useLocalStorage('localization', {
    currentLanguage: 'en',
    isRtl: false,
  });
  return (
    <div className='albums-footer-wrapper presentational-wrapper'>
      {Display ? (
        <div className='images-more-wrapper'>
          {data && data.result && data.result.length > 0 && (
            <div className='slide-images'>
              {data.result
                .filter((item, index) => index < 3)
                .map((item, index) => (
                  <ButtonBase
                    className='slide-image'
                    style={{
                      zIndex: index,
                      transform: `translateX(${(language.isRtl && -(index * 40)) || (index * 40)
                        }%)`,
                    }}
                    onClick={activeImageHandler(data.result, index, data)}
                  >
                    <LoadableImageComponant
                      classes='slide-image'
                      key={`albumImageSliderRef${index + 1}`}
                      alt={t(`${translationPath}location-image`)}
                      src={
                        (item.fileId && getDownloadableLink(item.fileId)) ||
                        DefaultImagesEnum.buildings.defaultImg
                      }
                    />
                  </ButtonBase>
                ))}
            </div>
          )}
          {data && data.result && data.result.length > 3 && (
            <ButtonBase
              className='images-more'
              onClick={activeImageHandler(data.result, 0, data)}
              style={{
                transform: `translateX(${(language.isRtl && -120) || 120
                  }%)`,
              }}
            >
              {data &&data.totalCount > 0 &&
                (`+ ${(data.totalCount - 3 <= 99 &&
                  data.totalCount - 3) ||
                  '99'}`) ||
                (`+ ${data.result.length}`)}
            </ButtonBase>
          )}
        </div>
      ) : (
        <div className='images-more-wrapper'>
          {data &&data.result &&
            data.result.length > 0 && (
              <div className='slide-images'>
                {data.result
                  .filter((item, index) => index < 3)
                  .map((item, index) => (
                    <ButtonBase
                      className='slide-image'
                      style={{
                        zIndex: index,
                        transform: `translateX(${(language.isRtl &&
                          -(index * 40)) || (index * 40)
                          }%)`,
                      }}
                      onClick={activeImageHandler(data.result, index, data)}
                    >
                      <LoadableImageComponant
                        classes='slide-image'
                        key={`albumImageSliderRef${index + 1}`}
                        alt={t(`${translationPath}location-image`)}
                        src={
                          (item.fileId && getDownloadableLink(item.fileId)) ||
                          DefaultImagesEnum.buildings.defaultImg
                        }
                      />
                    </ButtonBase>
                  ))}
              </div>
            )}
          {data &&data.result &&
            data.result.length > 3 && (
              <ButtonBase
                className='images-more'
                onClick={activeImageHandler(data.result, 0, data)}
                style={{
                  transform: `translateX(${(language.isRtl && -120) || 120
                    }%)`,
                }}
              >
                {data &&data.totalCount > 0 &&
                  (`+ ${(data.totalCount - 3 <= 99 &&
                    data.totalCount - 3) ||
                    '99'}`) ||
                  (`+ ${data.result.length}`)}
              </ButtonBase>
            )}
        </div>
      )}
      <div className='footer-actions-wrapper px-1'>
        {Display === UnitProfileImagesCardActionEnum.Show && (
          <PermissionsComponent
            permissionsList={Object.values(ImageGalleryPermissions)}
            permissionsId={ImageGalleryPermissions.DeleteAlbum.permissionsId}
          >
            <ButtonBase
              className='btns-icon theme-transparent mx-1'
              onClick={() => onFooterActionsClicked(ActionsEnum.delete.key, activeCategory)}
            >
              <span className={`${ActionsEnum.delete.icon} c-warning`} />
            </ButtonBase>
          </PermissionsComponent>
        )}
      </div>
    </div>
  );
};
AlbumsFooterComponent.propTypes = {
  hideIcon: PropTypes.bool.isRequired,
  Display: PropTypes.instanceOf(UnitProfileImagesCardActionEnum).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  onFooterActionsClicked: PropTypes.func.isRequired,
  activeImageHandler: PropTypes.func.isRequired,
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
};
